<template>
    <tr>
        <td class="text-center pt-2">
            <b-link
                :title="iconTitle"
                :disabled="disableClick"
                @click="setDefaultContact"
            >
                <i class="fa-fw fa-lg" :class="selectedIcon"></i>
            </b-link>
        </td>
        <td>
            <firstname-form
                :key="'firstname' + contact.id"
                :contact="contact"
                @contact-has-changed="$emit('contact-is-updated')"/>
        </td>
        <td>
            <surname-form
                :key="'surname' + contact.id"
                :contact="contact"
                @contact-has-changed="$emit('contact-is-updated')"/>
        </td>
        <td>
            <title-form
                :key="'title' + contact.id"
                :contact="contact"
                @contact-has-changed="$emit('contact-is-updated')"/>
        </td>
        <td>
            <email-form
                :key="'email' + contact.id"
                :contact="contact"
                @contact-has-changed="$emit('contact-is-updated')"/>
        </td>
        <td>
            <phone-form
                :key="'phone' + contact.id"
                :contact="contact"
                @contact-has-changed="$emit('contact-is-updated')"/>
        </td>
        <td class="text-center pt-2">
            <representative-switch
                :key="'switch' + contact.id"
                :contact="contact"
            />
        </td>
        <!--        <td class="text-center pt-2">-->
        <!--            <app-access-switch-->
        <!--                :key="'switch' + contact.id"-->
        <!--                :contact="contact"-->
        <!--            />-->
        <!--        </td>-->
        <td class="text-center pt-2">
            <b-link
                v-if="isChief"
                :disabled="isChief"
                title="Ce contact ne peut être supprimé car il est dirigeant de cette société"
                @click="showConfirmationModal()"
            >
                <i class="fas fa-fw fa-trash-alt text-light"></i>
            </b-link>
            <b-link v-else :disabled="isChief" @click="showConfirmationModal()">
                <i class="fas fa-fw fa-trash-alt text-danger"></i>
            </b-link>
        </td>
    </tr>
</template>

<script>
import FirstnameForm from './FirstnameForm'
import SurnameForm from './SurnameForm'
import TitleForm from './TitleForm'
import EmailForm from './EmailForm'
import PhoneForm from './PhoneForm'
import AppAccessSwitch from './AppAccessSwitch'
import RepresentativeSwitch from "./ReprsentativeSwitch.vue";

export default {
    name: 'ContactEdit',

    components: {
        RepresentativeSwitch,
        AppAccessSwitch,
        PhoneForm,
        EmailForm,
        TitleForm,
        FirstnameForm,
        SurnameForm,
    },

    props: {
        contact: null,
        chiefs: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            form: {},
        }
    },

    computed: {
        selectedIcon() {
            return this.contact.default_contact === 1
                ? 'fas fa-user-circle text-primary'
                : 'fal fa-circle'
        },

        disableClick() {
            return this.contact.default_contact === 1
        },

        iconTitle() {
            return this.contact.default_contact === 1
                ? 'Cette personne est le contact par défaut'
                : 'Cliquer pour définir cette personne comme contact par défaut'
        },

        isChief() {
            return this.chiefs === null || this.chiefs.length === 0
                ? false
                : this.chiefs.filter(
                (item) =>
                    item.chief_data.id ===
                    this.contact.physical_person_id &&
                    item.chief_type === 'physical'
            ).length > 0
        },
    },

    methods: {
        setDefaultContact() {
            this.form.default_contact = 1
            this.updateContact()
        },

        async updateContact() {
            try {
                await axios.put(
                    `/clientContacts/${this.contact.id}/physicalPersons/${this.contact.physical_person_id}`,
                    this.form
                )
                this.$emit('contact-is-updated')
            } catch (error) {
                console.log(error)
            }
        },

        showConfirmationModal() {
            this.$bvModal
                .msgBoxConfirm(
                    'Etes vous sûr·e de vouloir supprimer ce contact ?',
                    {
                        title: 'Confirmation',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Supprimer',
                        cancelTitle: 'Annuler',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                        noFade: false,
                    }
                )
                .then((value) => {
                    //
                    if (value) {
                        this.deleteItem()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        async deleteItem() {
            try {
                await axios.delete(
                    `/clientContacts/${this.contact.id}/physicalPersons/${this.contact.physical_person_id}`
                )
                this.$emit('contact-is-deleted')
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
